import { BorderWidth, Color, HorizontalFlex, MediumTextM, Space } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const CustomHeaderContainer = styled(HorizontalFlex)`
  border-bottom: ${BorderWidth.V1} solid ${Color.Neutral.V40};
  max-height: 64px;
  height: 64px;
  align-items: center;
`;

export const IbabsDebrief = styled.span`
  color: ${Color.Neutral.V40};
  display: flex;
  gap: ${Space.V12};

  > .productName {
    color: ${Color.Neutral.V70};
  }
`;

export const AIPoweredText = styled(MediumTextM)`
  color: ${Color.Blue.V50};
`;
